import { apiGet, apiPost, apiPut } from "./apiClient";

function unwrapResponse(response) {
  if (!response?.data?.success) {
    throw new Error(response?.data?.message || "Waiting-price report request failed.");
  }
  return response.data.data;
}

export async function fetchWaitingPriceReportConfig() {
  return unwrapResponse(await apiGet("/waiting-price-reports/config"));
}

export async function saveWaitingPriceReportConfig(config) {
  return unwrapResponse(await apiPut("/waiting-price-reports/config", config));
}

export async function fetchWaitingPriceReportUsers(userTypes = []) {
  const params = new URLSearchParams();
  if (userTypes.length) params.set("user_types", [...new Set(userTypes)].join(","));
  params.set("include_wati_status", "1");
  return unwrapResponse(await apiGet(`/whatsapp/get_users?${params.toString()}`));
}

export async function fetchWaitingPriceReportUserTypes() {
  return unwrapResponse(await apiPost("/usertypes/get_user_types", {}));
}

export async function fetchWaitingPriceReportJobs({
  page = 1,
  pageSize = 20,
  status = "",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  if (status) params.set("status", status);
  return unwrapResponse(await apiGet(`/waiting-price-reports/jobs?${params.toString()}`));
}
